import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import container from '@/container';
import 'bootstrap';
import 'devextreme/dist/css/dx.material.blue.light.css';
import 'devextreme/dist/css/dx.common.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import '@/css/Sass/App.scss';
import PortalVue from 'portal-vue';
import VueScreen from 'vue-screen';

Vue.config.productionTip = false;

container.init(store);

Vue.use(VueScreen, 'bootstrap');
Vue.use(PortalVue);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
